<template>
  <v-img
    class="grow hidden-sm-and-down"
    contain
    max-height="200"
    width="100%"
    position="top right"
    :src="require('../../../static/img/bubbles1.png')"
  />
</template>

<script>
  export default {
    name: 'BaseBubble1',
  }
</script>



// WEBPACK FOOTER //
// src/components/base/Bubble1.vue